export default __webpack_public_path__ + "static/media/img4.7ccd3b70.PNG";